export default __webpack_public_path__ + "./images/ly.4414ba61.png";